import Mixpanel, { type Dict as MixpanelPropertyTypes } from 'mixpanel-browser'

import { replacer } from '~/helpers/functions'

export enum MixpanelEvent {
  AppLoad = 'App Load',
  UserLogin = 'User Login',
  UserLogout = 'User Logout',
  SessionStart = 'Session Start',
  SessionEnd = 'Session End',
  ActiveScreenTime = 'Active Screen Time',
  PassiveScreenTime = 'Passive Screen Time',
  HotkeyUsed = 'Hotkey Used',
  CommandKClicked = 'Command-K Clicked',
  RadiusTabView = 'Radius Tab View',
  CostCenterSelected = 'CostCenter Selected',
  FilterClicked = 'Filter Clicked',
  DriverInTableClicked = 'Driver In List Clicked',
  TMWOrderInTableClicked = 'Driver Visibility Trip Details Selected',
  DVDLegHeaderOpened = 'Driver Visibility Leg Header Opened',
  DVDLegHeaderClosed = 'Driver Visibility Leg Header Closed',
  DVDLoadOpenedFromLeg = 'Driver Visibility Load Opened From Leg',
  StopInTableClicked = 'Stop In List Clicked',
  DriverOnMapClicked = 'Driver On Map Clicked',
  AsyncButtonClicked = 'Async Button Clicked',
  MarkerLabelsToggleClicked = 'Map Marker Labels Toggled Clicked',
  MapExpandContractToggleClicked = 'Map Expand/Contract Toggle Clicked',
  ActionMenuOpened = 'Action Menu Opened',
  ActionMenuItemSelected = 'Action Menu Item Selected',
  DriverVisibilityDutyStatusChanged = 'Driver Visibility Duty Status Changed',
  NotificationCenterOpened = 'Notification Center Opened',
  NotificationSelected = 'Notification Selected',
  OpenNewTabClicked = 'Click To Open New Tab',
  RadiusUserGuideViewed = 'Radius User Guide Viewed',

  /** Load Board */
  LoadBoardSearch = 'Load Board Search',
  LoadBoardFilter = 'Load Board Filter',
  LoadBoardSearchCategorySelected = 'Load Board Search Category Selected',
  LoadBoardPageSelected = 'Load Board Page Selected',
  LoadBoardSortingChanged = 'Load Board Sorting Changed',
  LoadBoardFilterChanged = 'Load Board Filter Changed',
  LoadBoardDetailView = 'Load Board Detail View',
  LoadBoardAssignDriver = 'Load Board Assign Driver',
  LoadBoardUnassignDriver = 'Load Board Unassign Driver',
  LoadBoardDispatch = 'Load Board Dispatch',
  LoadBoardDetailViewLegSelected = 'Load Board Detail View Leg Selected',
  LoadBoardEditStop = 'Load Board Edit Stop',
  LoadBoardDeleteStop = 'Load Board Delete Stop',
  LoadBoardReorderStop = 'Load Board Reorder Stop',
  LoadBoardAddStop = 'Load Board Add Stop',
  LoadBoardAddLayoverStop = 'Load Board Add Layover Stop',
  LoadBoardAddCompletedLayoverStop = 'Load Board Add Completed Layover Stop',
  LoadBoardAddCompletedStop = 'Load Board Add Completed Stop',
  LoadBoardDuplicateStop = 'Load Board Duplicate Stop',
  LoadBoardCreateLoad = 'Load Board Create Load',
  LoadBoardEditLegPlannedStartTime = 'Load Board Edit Leg Planned Start Time',
  LoadBoardLegCreated = 'Load Board Leg Created',
  LoadBoardEditBackhaulCode = 'Load Board Edit Backhaul Code',
  LoadBoardAssignTractor = 'Load Board Assign Tractor',
  LoadBoardUnassignTractor = 'Load Board Unassign Tractor',
  LoadBoardSignOffOpenModal = 'Load Board Sign Off Open Modal',
  LoadBoardSignOffComplete = 'Load Board Sign Off Complete',
  LoadBoardSignOffPDFViewed = 'Load Board Sign-Off PDF Viewed',
  LoadBoardSignOffModalOpened = 'Load Board Sign-Off Modal Opened',
  LoadBoardCancelLoad = 'Load Board Cancel Load',
  LoadBoardTenderLoad = 'Load Tendered',
  LoadBoardWithdrawLoadTender = 'Load Tender Withdrawn',
  LoadBoardReferenceDeleted = 'Load Board Reference Deleted',
  LoadBoardReferenceEdited = 'Load Board Reference Edited',
  LoadBoardReferenceAdded = 'Load Board Reference Added',
  LoadBoardBillToEdited = 'Load Board Bill-To Edited',
  LoadBoardResourceChanged = 'Load Board Resource Changed',
  LoadBoardManualArriveDepart = 'Load Board Manual Arrive Depart',
  LoadBoardCreateNote = 'Load Board Create Note',
  LoadBoardDeleteNote = 'Load Board Delete Note',
  LoadBoardDeleteFreightRecord = 'Load Board Delete Freight Record',
  LoadBoardCreateFreightRecord = 'Load Board Create Freight Record',
  LoadBoardEditFreightRecord = 'Load Board Edit Freight Record',
  LoadBoardCreateOsdRecord = 'Load Board Create OSD Record',
  LoadBoardUpdateOsdRecord = 'Load Board Update OSD Record',
  LoadBoardEquipmentMoveCreated = 'Load Board Equipment Move Created',
  LoadBoardUpdateLatenessReason = 'Load Board Update Lateness Reason',
  LoadBoardUpdateExceptionDescription = 'Load Board Update Exception Description',
  LoadBoardUpdateExceptionReason = 'Load Board Update Exception Reason',
  LoadBoardBulkUpdateDelayReason = 'Load Board Bulk Update Delay Reason',
  LoadBoardAssignTrailer = 'Load Board Assign Trailer',
  LoadBoardUnassignTrailer = 'Load Board Unassign Trailer',
  LoadBoardTrailerChange = 'Load Board Trailer Change',
  LoadBoardDeleteDropAndHook = 'Load Board Delete Drop and Hook',
  LoadBoardAssignCarrier = 'Load Board Assign Carrier',
  LoadBoardUnassignCarrier = 'Load Board Unassign Carrier',
  LoadBoardMergeLeg = 'Load Board Leg Merged',
  LoadBoardSharingButtonClicked = 'Load Board Sharing Button Clicked',
  LoadBoardCSVExported = 'Load Board CSV Exported',
  LoadBoardEditRouteCode = 'Load Board Edit Route Code',
  LoadBoardSaveFilters = 'Load Board Save Filters',
  LoadBoardReorderCompletedStops = 'Load Board Reorder Completed Stops',
  LoadBoardUndoStop = 'Load Board Undo Stop',
  LoadBoardDispatchWarningShow = 'Load Board Dispatch Warning Show',
  LoadBoardDispatchWarningCancel = 'Load Board Dispatch Warning Cancel',
  LoadBoardEmptyStateClicked = 'Load Board Empty State Clicked',
  LoadBoardNoteCellClicked = 'Load Board Note Cell Clicked',
  LoadBoardDocCellClicked = 'Load Board Doc Cell Clicked',

  /** Home Page */

  HomePageCardSelected = 'Home Page Card Selected',
  NotificationHideResolved = 'Notification Hide Resolved',
  NotificationShowResolved = 'Notification Show Resolved',
  NotificationMarkAsRead = 'Notification Mark As Read',
  HomePageCostCenterFilter = 'Home Page Cost Center Filter',
  HomePageDateFilter = 'Home Page Date Filter',

  /** Active Exceptions */
  ActiveExceptionsCardSelected = 'Active Exceptions Card Selected',
  ActiveExceptionsPageSelected = 'Active Exceptions Page Selected',
  ActiveExceptionsFilter = 'Active Exceptions Filter',
  ActiveExceptionsUpdateExceptionReviewStatus = 'Active Exceptions Update Exception Review Status',
  ActiveExceptionsUpdateExceptionDescription = 'Active Exceptions Update Exception Description',
  ActiveExceptionsUpdateExceptionReason = 'Active Exceptions Update Exception Reason',
  ActiveExceptionsBulkUpdateDelayReason = 'Active Exceptions Bulk Update Delay Reason',

  /** Attempt and Reschedule */
  LoadBoardRescheduleStop = 'Load Board Reschedule Stop',
  LoadBoardAttemptStop = 'Load Board Attempt Stop',
  LoadBoardSkipStop = 'Load Board Skip Stop',

  /**Planning Board */
  PlanningBoardFilterChanged = 'Planning Board Filter Changed',
  PlanningBoardAssignDriver = 'Planning Board Assign Driver',
  PlanningBoardUnassignDriver = 'Planning Board Unassign Driver',
  PlanningBoardUpdatePlannedStartTime = 'Planning Board Update Planned Start Time',

  /** Facility Tool */
  FacilityToolSearch = 'Facility Tool Search',
  FacilityToolFilter = 'Facility Tool Filter',
  FacilityListReset = 'Facility List Reset',
  FacilityToolPageSelected = 'Facility Tool Page Selected',
  FacilityEditContact = 'Facility Edit Contact',
  FacilityDeleteContact = 'Facility Delete Contact',
  FacilityCreateContact = 'Facility Create Contact',
  FacilityEditNote = 'Facility Edit Note',
  FacilityDeleteNote = 'Facility Delete Note',
  FacilityCreateNote = 'Facility Create Note',
  FacilityCreated = 'Facility Created',
  FacilityHoursViewed = 'Facility Hours Viewed',
  FacilityDetailView = 'Facility Detail View',

  /** Equipment Tool */
  EquipmentEditSpecs = 'Equipment Edit Specs',
  EquipmentNoteAdded = 'Equipment Note Added',
  EquipmentNoteDeleted = 'Equipment Note Deleted',
  EquipmentSearch = 'Equipment Search',
  EquipmentToolFilter = 'Equipment Tool Filter',
  EquipmentToolTabSelected = 'Equipment Tool Tab Selected',
  EquipmentServiceEventEdited = 'Equipment Service Event Edited',
  EquipmentServiceEventStarted = 'Equipment Service Event Started',
  EquipmentServiceEventCompleted = 'Equipment Service Event Completed',
  EquipmentServiceEventAdded = 'Equipment Service Event Added',
  EquipmentServiceEventDeleted = 'Equipment Service Event Deleted',
  EquipmentCreated = 'Equipment Created',
  EquipmentCodeCenterUpdated = 'Equipment Cost Center Updated',

  /** Efficiency Management Dashboard */
  EfficiencyManagementFilter = 'Efficiency Management Filter',
  EfficiencyManagementSortingChanged = 'Efficiency Management Sorting Changed',
  EfficiencyManagementCostCenterRowOpened = 'Efficiency Management Cost Center Row Opened',
  EfficiencyManagementCostCenterRowClosed = 'Efficiency Management Cost Center Row Closed',
  EfficiencyManagementEventInvestigationOpened = 'Efficiency Management Event Investigation Opened',
  EfficiencyManagementEventTagAssigned = 'Efficiency Management Event Tag Assigned',
  EfficiencyManagementEventTagChanged = 'Efficiency Management Event Tag Changed',
  EfficiencyManagementEventListSorted = 'Efficiency Management Event List Sorted',
  EfficiencyManagementEventFiltered = 'Efficiency Management Event Filtered',
  EfficiencyManagementTimelineInteraction = 'Efficiency Management Timeline Interaction',

  /** Mobile Dispatch */
  MobileDispatchViewMore = 'Mobile Dispatch View More',
  MobileLoadBoardDetailView = 'Mobile Load Board Detail View',
  MobileLoadBoardViewException = 'Mobile Load Board View Exception',
  // MobileDispatchTabSelected = 'Mobile Dispatch Tab Selected',
  MobilePlanningTabSelected = 'Mobile Planning Tab Selected',
  MobileMonitoringTabSelected = 'Mobile Monitoring Tab Selected',
  MobileReviewTabSelected = 'Mobile Review Tab Selected',
  MobileViewNotesDetails = 'Mobile View Notes Details',
  MobileViewFreightDetails = 'Mobile View Freight Details',

  MobileLoadBoardFilterChanged = 'Mobile Load Board Filter Changed',

  /** Loadboard/Rydershare Detail View */
  DocumentsTabPreview = 'Preview Documents Tab Image/PDF',
  DocumentsTabDownload = 'Download Document From Documents Tab',
  DocumentsTabFilterChanged = 'Document Tab Document Type Filter Changed',
  DocumentsTabSortChanged = 'Document Tab Document Sort Direction Changed',
  TabSelected = 'Loadboard Detail View Tab Selected',
  RydershareMapExpandContractToggleClicked = 'Customer Visibility Map Expand/Contract Toggle Clicked',
  LoadJsonDownload = 'Load JSON Download',

  /** CVT */
  CVTAppliedFilterAllChipsCleared = 'CVT Applied Filter All Chips Cleared',
  CVTAppliedFilterChipCleared = 'CVT Applied Filter Chip Cleared',
  CVTAppliedFilterChipHovered = 'CVT Applied Filter Chip Hovered',
  CVTAssociatedShipmentListRowClicked = 'CVT Associated Shipment List Row Clicked',
  CVTAuditTrailAllDetailsExpanded = 'CVT Audit Trail All Details Expanded',
  CVTAuditTrailDetailExpanded = 'CVT Audit Trail Detail Expanded',
  CVTAuditTrailFiltersApplied = 'CVT Audit Trail Filters Applied',
  CVTColumnSorted = 'CVT Column Sorted',
  CVTCompoundFilterCategoryCleared = 'CVT Compound Filter Category Cleared',
  CVTCompoundFilterModalClosed = 'CVT Compound Filter Modal Closed',
  CVTCompoundFilterModalOpened = 'CVT Compound Filter Modal Opened',
  CVTCompoundFilterOptionToggled = 'CVT Compound Filter Option Toggled',
  CVTCompoundFilterOptionsBulkToggled = 'CVT Compound Filter Options Bulk Toggled',
  CVTCompoundFilterSearchAttempted = 'CVT Compound Filter Search Attempted',
  CVTCompoundFilterSelectionRemoved = 'CVT Compound Filter Selection Removed',
  CVTCurrentLocationCardHovered = 'CVT Current Location Card Hovered',
  CVTCustomerFeedbackSubmitted = 'CVT Customer Feedback Submitted',
  CVTEtaFreshnessIconHovered = 'CVT ETA Freshness Icon Hovered',
  CVTExceptionDashboardExceptionTypesBulkToggled = 'CVT Exception Dashboard Exception Types Bulk Toggled',
  CVTExceptionPaginationClicked = 'CVT Exception Pagination Clicked',
  CVTExceptionRowClicked = 'CVT Exception Row Clicked',
  CVTExceptionsDetailPanelOpened = 'CVT Exceptions Detail Panel Opened',
  CVTExceptionsDetailRyderNumberLinkClicked = 'CVT Exceptions Detail Ryder # Link Clicked',
  CVTExceptionsDetailShipmentRowClicked = 'CVT Exceptions Detail Shipment Row Clicked',
  CVTExceptionsTabViewed = 'CVT Exceptions Tab Viewed',
  CVTFiltersApplied = 'CVT Filters Applied',
  CVTIntegratedViewDetailTabViewed = 'CVT Integrated View Detail Tab Viewed',
  CVTIntegratedViewFilterGroupChanged = 'CVT Integrated View Filter Group Changed',
  CVTIntegratedViewFiltersApplied = 'CVT Integrated View Filters Applied',
  CVTIntegratedViewLoadCSVExported = 'CVT Integrated View Load CSV Exported',
  CVTIntegratedViewLoadRowClicked = 'CVT Integrated View Load Row Clicked',
  CVTIntegratedViewPaginationClicked = 'CVT Integrated View Pagination Clicked',
  CVTIntegratedViewResetFiltersClicked = 'CVT Integrated View Reset Filters Clicked',
  CVTIntegratedViewSearchCleared = 'CVT Integrated View Search Cleared',
  CVTIntegratedViewSearchPerformed = 'CVT Integrated View Search Performed',
  CVTIntegratedViewSearchResultClicked = 'CVT Integrated View Search Result Clicked',
  CVTIntegratedViewShipmentCSVExported = 'CVT Integrated View Shipment CSV Exported',
  CVTIntegratedViewShipmentRowClicked = 'CVT Integrated View Shipment Row Clicked',
  CVTIntegratedViewToggleSwitched = 'CVT Integrated View Toggle Switched',
  CVTIntegratedViewSaveFilters = 'CVT Integrated View Save Filters',
  CVTLoadBoardColumnTooltipViewed = 'CVT Load Board Column Tooltip Viewed',
  CVTLoadDetailsColumnTooltipViewed = 'CVT Load Details Column Tooltip Viewed',
  CVTLoadboardCSVExported = 'CVT Loadboard CSV Exported',
  CVTLoadDetailLoaded = 'CVT Load Detail Page Loaded',
  CVTLoadReferencesModalTabSelected = 'CVT Load References Modal Tab Selected',
  CVTLoadReferencesViewAllClicked = 'CVT Load References View All Clicked',
  CVTLoadSaveFilters = 'CVT Load Save Filters',
  CVTSharingButtonClicked = 'CVT Sharing Button Clicked',
  CVTShipmentBoardColumnTooltipViewed = 'CVT Shipment Board Column Tooltip Viewed',
  CVTShipmentDetailsColumnTooltipViewed = 'CVT Shipment Details Column Tooltip Viewed',
  CVTShipmentBoardCSVExported = 'CVT Shipment Board CSV Exported',
  CVTShipmentDetailLoaded = 'CVT Shipment Detail Page Loaded',
  CVTShipmentMapCenterClicked = 'CVT Shipment Map Center Clicked',
  CVTShipmentReferencesModalTabSelected = 'CVT Shipment References Modal Tab Selected',
  CVTShipmentReferencesViewAllClicked = 'CVT Shipment References View All Clicked',
  CVTShipmentSaveFilters = 'CVT Shipment Save Filters',
  CVTStopShipmentsDrawerOpened = 'CVT Stop Shipments Drawer Opened',
  CVTStopShipmentsDrawerRowSelected = 'CVT Stop Shipments Drawer Row Selected',
  CVTTractorMarkerHovered = 'CVT Tractor Marker Hovered',
  CVTUsageTabViewed = 'CVT Usage Tab Viewed',
  CVTShipmentWhiteGloveSet = 'CVT Shipment White Glove Set',
  CVTNetworkViewTabChanged = 'CVT Network View Tab Changed',
  CVTNetworkViewListRowClicked = 'CVT Network View List Row Clicked',
  CVTNetworkViewMapMarkerClicked = 'CVT Network View Map Marker Clicked',
  CVTLoadBoardStatusOverviewOpened = 'CVT Load Board Status Overview Opened',
  CVTLoadBoardStatusOverviewClosed = 'CVT Load Board Status Overview Closed',
  CVTShipmentBoardStatusOverviewOpened = 'CVT Shipment Board Status Overview Opened',
  CVTShipmentBoardStatusOverviewClosed = 'CVT Shipment Board Status Overview Closed',
  CVTLocationFilterSearchAttempted = 'CVT Location Filter Search Attempted',
  CVTNetworkViewFiltersApplied = 'CVT Network View Filters Applied',
  CVTNetworkViewFiltersReset = 'CVT Network View Filters Reset',
  CVTNetworkViewSearchCleared = 'CVT Network View Search Cleared',
  CVTNetworkViewSearchPerformed = 'CVT Network View Search Performed',
  CVTNetworkViewSearchResultClicked = 'CVT Network View Search Result Clicked',
  CVTPrimaryReferenceCopied = 'CVT Primary Reference Copied',
  CVTRyderNumberCopied = 'CVT Ryder Number Copied',
  CVTHelpMenuOpened = 'CVT Help Menu Opened',
  CVTContactSupportClicked = 'CVT Contact Support Clicked',
  CVTRequestTrainingClicked = 'CVT Request Training Clicked',
  CVTProvideFeedbackClicked = 'CVT Provide Feedback Clicked',
  CVTTrainingRequestSubmitted = 'CVT Training Request Submitted',
  CVTTrainingRequestCancelled = 'CVT Training Request Cancelled',
  CVTFeedbackSubmitted = 'CVT Feedback Submitted',
  CVTFeedbackCancelled = 'CVT Feedback Cancelled',
  RydershareFilter = 'Customer Visibility Filter',

  /** User Settings */
  UserSettingsOpen = 'User Settings Open Sidebar',
  UserSettingsFavoriteCostCenterChanged = 'User Settings Favorite Cost Center Changed',
  UserSettingsHomePageChanged = 'User Settings Home Page Changed',

  /** Tracking Page */
  TrackingPageVisited = 'Tracking Page Visited',

  /** Experiments */
  ExperimentStarted = '$experiment_started',
}

/** Customer page key -> Mixpanel `page` */
export const MIXPANEL_CUSTOMER_PAGE_NAMES: Record<string, string> = {
  visibility: 'Integrated View',
  visibilityExceptions: 'Exceptions',
  visibilityLoadDetail: 'Load Detail',
  visibilityShipmentDetail: 'Shipment Detail',
  visibilityShipmentLoadDetail: 'Load Detail',
  visibilityLoadShipmentDetail: 'Shipment Detail',
  shipments: 'Shipments',
  shipmentsExceptions: 'Exceptions',
  shipmentsDetail: 'Shipment Detail',
  shipmentsLoadDetail: 'Load Detail',
  customerVisibility: 'Visibility',
  customerVisibilityExceptions: 'Exceptions',
  customerVisibilityDetail: 'Load Detail',
  network: 'Network View',
  networkLoad: 'Load Detail',
  usage: 'Usage',
}

export const startMixpanelClient = (): void => {
  if (
    process.env.NEXT_PUBLIC_ENV !== 'development' &&
    process.env.NEXT_PUBLIC_MIXPANEL_KEY
  ) {
    Mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_KEY ?? '', {
      record_sessions_percent: 20,
      record_mask_text_selector: '',
      record_block_selector: '',
    })

    // Appcues looks for `window.mixpanel` to forward Appcues events
    // into Mixpanel automatically, so exposing it here to enable
    // the Appcues <> Mixpanel integration.
    if (typeof window !== 'undefined') {
      window.mixpanel = Mixpanel
    }
  }
}

export const identifyUser = (userId: string): void => {
  if (process.env.NEXT_PUBLIC_ENV !== 'development') {
    Mixpanel.identify(userId)
  }
}

export const register = (data: MixpanelPropertyTypes): void => {
  if (process.env.NEXT_PUBLIC_ENV !== 'development') {
    Mixpanel.register(data)
    Mixpanel.people.set(data)
  }
}

export const resetMixpanel = (): void => {
  if (process.env.NEXT_PUBLIC_ENV !== 'development') {
    Mixpanel.reset()
  }
}

export const track = (event: MixpanelEvent, extraData = {}): void => {
  if (process.env.NEXT_PUBLIC_ENV !== 'development') {
    Mixpanel.track(event, {
      ...extraData,
      tmsVersion: process.env.VERSION,
      eventCreatedAt: new Date().toISOString(),
    })
  } else {
    // eslint-disable-next-line no-console
    console.log(
      `Mixpanel track: ${event}, data: ${JSON.stringify(extraData, replacer)}`
    )
  }
}

export const timeEvent = (event: MixpanelEvent): void => {
  if (process.env.NEXT_PUBLIC_ENV !== 'development') {
    Mixpanel.time_event(event)
  } else {
    console.log(`Mixpanel time_event: ${event}`) // eslint-disable-line no-console
  }
}
